import { StateInterface } from "./state";
import { MutationTree } from "vuex";
import Schedule from "@/classes/Schedule";

const mutation: MutationTree<StateInterface> = {
  setAllUserPlaylists: (state, playlists) =>
    (state.allUserPlaylists = playlists),

  /**
   * set the schedule for a playlist
   */
  setPlaylistSchedules: (state, schedules: Schedule[]) => {
    const playlist = state.allUserPlaylists.find(
      (pl) => pl.ID === schedules[0].PLID
    );
    if (playlist) {
      playlist.schedules = schedules;
    }
  },

  updatePlaylist: (state, payload) => {
    const pl = state.allUserPlaylists.find(
      (pl) => pl.ID === payload.playlistId
    );

    if (pl) {
      pl.contentIds = payload.contentIds;
    }
  },

  editPlaylistByID: (state, { plID, plName, plColor }) => {
    const playlist = state.allUserPlaylists.find((pl) => pl.ID === plID);
    if (playlist) {
      playlist.NAME = plName;
      playlist.COLOR = plColor;
    }
  },

  removePlaylist: (state, playlistId) => {
    const plIndex = state.allUserPlaylists.findIndex(
      (pl) => pl.ID === playlistId
    );

    if (plIndex >= 0) {
      state.allUserPlaylists.splice(plIndex, 1);
    }
  },
  updateDevicePlaylists: (state, { deviceId, playlistIds }) => {
    for(const [index, playlist] of state.allUserPlaylists.entries()) {
      // Remove device from all playlists
      if(playlist.deviceIds.includes(deviceId)) {
        state.allUserPlaylists[index].deviceIds = state.allUserPlaylists[index].deviceIds.filter(id => id !== deviceId);
      }
      // Add Device to according playlists 
      if(playlistIds.includes(playlist.ID)) {
        state.allUserPlaylists[index].deviceIds.push(deviceId);
      }
    }
  },
  updateGroupPlaylists: (state, { groupId, playlistIds }) => {
    for(const [index, playlist] of state.allUserPlaylists.entries()) {
      // Remove device from all playlists
      if(playlist.groupIds.includes(groupId)) {
        state.allUserPlaylists[index].groupIds = state.allUserPlaylists[index].groupIds.filter(id => id !== groupId);
      }
      // Add Device to according playlists 
      if(playlistIds.includes(playlist.ID)) {
        state.allUserPlaylists[index].groupIds.push(groupId);
      }
    }
  },
};

export default mutation;
